module.exports = __webpack_public_path__ + "d4c7f6a671031576584944066a03c453.pdf";